// PageNotFound.js
import React from 'react';

const PageNotFound = () => (
  <div className="page-not-found container">
    <h1>404 - Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
    <a href="/homepage">Go to Home Page</a>
  </div>
);

export default PageNotFound;